import { render, staticRenderFns } from "./Error_mobile.vue?vue&type=template&id=0a495a7a&scoped=true&"
import script from "./Error_mobile.vue?vue&type=script&lang=js&"
export * from "./Error_mobile.vue?vue&type=script&lang=js&"
import style0 from "./Error_mobile.vue?vue&type=style&index=0&id=0a495a7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a495a7a",
  null
  
)

export default component.exports